<template>
  <div class="tab-discharging-trucking">
    <tab-discharging-trucking-UICustom-layout :element-blocks="elementBlocks" style="min-width: 1200px;">
      <div slot="DoorToDoorLoading" class="section">
        <span class="title">
          {{ $t('SeaExport.DoorToDoorLoading') }}
          <span
            style="color: red; font-weight:lighter;margin:30px;"
          >注：1、{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate') }}；2、<span v-if="job.dischargingPortDoor">若需指定目的港运输公司，请维护运输公司字段，未维护时尾程商务会进行分配</span></span>
          <el-button v-if="(job.lob === 'SE' || job.lob === 'AE') && readonly && showSync" type="primary" @click="exportSyncImport">{{ $t('SeaExport.Synchronization') }}</el-button>
        </span>
        <div style="display:flex;flex-direction:column">
          <div v-show="job.multipleDischargingPickups">
            <cargo-ag-grid
              v-if="top.visible"
              no="1"
              :config-module="topConfigModuel"
              :grid-options="top.gridOptions"
              :column-defs="topColumnDefs"
              :row-data="trucking"
              style="width:100%;"
              @gridReady="params=>{topGridApi=params.api}"
            />
          </div>
          <div v-if="!isMaster && job.multipleDischargingPickups" class="app-main-inner-row operations" style="padding:5px 0">
            <div v-show="cooperateEdit" class="triggers">
              <div>
                <el-button
                  no="2"
                  type="primary"
                  :disabled="readonly||!addEnable"
                  @click="copyNewHandler"
                >{{ $t('SeaExport.copyAndAddPoItems') }}</el-button>
                <el-button no="3" type="primary" :disabled="readonly||!addEnable" @click="addHandler">{{ $t('SeaExport.Add2') }}</el-button>
                <el-button no="4" type="danger" :disabled="readonly" @click="delHandler">{{ $t('SeaExport.Delete') }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template>
        <el-form-item v-if="elementDict.multipleDischargingPickups.viewable" slot="multipleDischargingPickups">
          <template slot="label">
            <el-checkbox
              v-model="job.multipleDischargingPickups"
              no="5.1"
              :disabled="readonly || action==='add'"
              @change="multiPickupsChangeHandler"
            >
              {{ elementDict.multipleDischargingPickups.label }}
            </el-checkbox>
          </template>
        </el-form-item>
        <el-form-item v-if="elementDict.quantity.viewable" slot="quantity">
          <line-label slot="label" :class="elementDict.quantity.isRequire ? 'blue' : ''" :label="elementDict.quantity.label" />
          <el-input-number
            no="6"
            :value="truckingInfo.quantity||undefined"
            :disabled="readonly"
            :min="0"
            :max="99999"
            :precision="0"
            controls-position="right"
            style="width: 400px"
            @input="val=>{truckingInfo.quantity=val}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.weight.viewable" slot="weight">
          <line-label slot="label" :class="elementDict.weight.isRequire ? 'blue' : ''" :label="elementDict.weight.label" />
          <el-input-number
            no="7"
            :value="truckingInfo.weight||undefined"
            :disabled="readonly"
            :min="0"
            :max="99999"
            :precision="3"
            controls-position="right"
            style="width: 400px"
            @input="val=>{truckingInfo.weight=val}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cubage.viewable" slot="cubage">
          <line-label slot="label" :class="elementDict.cubage.isRequire ? 'blue' : ''" :label="elementDict.cubage.label" />
          <el-input-number
            no="8"
            :value="truckingInfo.cubage||undefined"
            :disabled="readonly"
            :min="0"
            :max="99999"
            :precision="3"
            controls-position="right"
            style="width: 400px"
            @input="val=>{truckingInfo.cubage=val}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.carryingCmp.viewable && !isSalesForSzfs" slot="carryingCmp" class="custom">
          <line-label slot="label" :class="elementDict.carryingCmp.isRequire ? 'blue' : ''" :label="elementDict.carryingCmp.label" />
          <cargo-company-select
            no="9"
            :disabled="readonly"
            :method-params="{truckCmp:true,active:true}"
            :default-value="truckingInfo.carryingCmp||''"
            style="width:400px; display:inline-block"
            @change="p=>{truckingInfo.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.driver.viewable && !isSalesForSzfs" slot="driver" class="custom">
          <line-label slot="label" :class="elementDict.driver.isRequire ? 'blue' : ''" :label="elementDict.driver.label" />
          <el-select
            v-model="truckingInfo.driver"
            :disabled="readonly"
            no="10"
            style="width:400px"
            :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
            :allow-create="true"
            :clearable="true"
            filterable
            @change="carryingContactsChangeHandler(false, false)"
            @blur="selectContactBlur"
          >
            <el-option
              v-for="(item,index) in carryingContacts"
              :key="index"
              :label="item.contactPerson"
              :value="item.contactPerson"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.loadingDate.viewable" slot="loadingDate" class="custom">
          <line-label slot="label" :class="elementDict.loadingDate.isRequire ? 'blue' : ''" :label="elementDict.loadingDate.label" />
          <el-date-picker
            ref="loadingDate"
            v-model="truckingInfo.loadingDate"
            :disabled="readonly"
            no="11"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width:400px"
            @blur="()=> { handleBlur('loadingDate', null, true, true, truckingInfo) }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.driverName.viewable && !isSalesForSzfs" slot="driverName" :disabled="txtEditEable" class="custom">
          <line-label slot="label" :class="elementDict.driverName.isRequire ? 'blue' : ''" :label="elementDict.driverName.label" />
          <el-input v-model="truckingInfo.driverName" :disabled="readonly" no="12" style="width:400px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.travelTime.viewable" slot="travelTime" class="custom">
          <line-label slot="label" :class="elementDict.travelTime.isRequire ? 'blue' : ''" :label="elementDict.travelTime.label" />
          <el-input-number v-model="truckingInfo.travelHour" :disabled="readonly" no="13" :min="0" controls-position="right" style="width:155px" />
          <span style="margin:10px">{{ $t('SeaExport.Hour') }}</span>
          <el-input-number
            v-model="truckingInfo.travelMinute"
            :disabled="readonly"
            no="14"
            :min="0"
            :max="59"
            controls-position="right"
            style="width:155px"
          />
          <span style="margin:10px">{{ $t('SeaExport.Minute') }}</span>
        </el-form-item>
        <el-form-item v-if="elementDict.doorMan.viewable" slot="doorMan" class="custom">
          <line-label slot="label" :class="elementDict.doorMan.isRequire ? 'blue' : ''" :label="elementDict.doorMan.label" />
          <el-input v-model="truckingInfo.doorMan" :disabled="readonly" no="15" style="width:400px" />
        </el-form-item>
        <el-form-item v-if="elementDict.doorAddr.viewable" slot="doorAddr" class="custom">
          <line-label slot="label" :class="elementDict.doorAddr.isRequire ? 'blue' : ''" :label="elementDict.doorAddr.label" />
          <el-input v-model="truckingInfo.doorAddr" :disabled="readonly" no="16" type="textarea" :rows="3" style="width:400px" />
        </el-form-item>
        <el-form-item v-if="elementDict.zipCode.viewable" slot="zipCode" class="custom">
          <line-label slot="label" :class="elementDict.zipCode.isRequire ? 'blue' : ''" :label="elementDict.zipCode.label" />
          <el-input v-model="truckingInfo.zipCode" :disabled="readonly" no="zipCode" style="width:400px" />
        </el-form-item>
        <el-form-item v-if="elementDict.cityCode.viewable" slot="cityCode" class="auto-width">
          <line-label slot="label" :class="elementDict.cityCode.isRequire ? 'blue' : ''" :label="elementDict.cityCode.label" />
          <cargo-advance-select
            no="17"
            :disabled="readonly"
            :tag-name="$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
            tag-value="code"
            :cache="false"
            filterable
            :default-value="truckingInfo.cityCode"
            :static-options="cityList"
            :placeholder="$t('SeaExport.PleaseSelect')"
            @parentCallBack="p=>{truckingInfo.cityCode=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.po.viewable" slot="po">
          <line-label slot="label" :class="elementDict.po.isRequire ? 'blue' : ''" :label="elementDict.po.label" />
          <el-input
            v-model="truckingInfo.po"
            no="po"
            :disabled="readonly"
            :filter-chars="false"
            type="textarea"
            :rows="3"
            style="width:400px"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exChangeAgent.viewable && !isSalesForSzfs" slot="exChangeAgent">
          <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
          <cargo-company-select
            :disabled="readonly"
            no="exChangeAgent"
            :method-params="{bookingAgent:true,active:true}"
            :default-value="truckingInfo.exChangeAgent||''"
            style="width:400px;display:inline-block"
            @change="onExChangeAgentChange"
          />
        </el-form-item>
      </template>
      <template>
        <el-form-item v-if="elementDict.soNo.viewable && job.multipleDischargingPickups" slot="soNo" label-width="100px" class="custom">
          <line-label slot="label" :class="elementDict.soNo.isRequire ? 'blue' : ''" :label="elementDict.soNo.label" />
          <so-no-selector v-model="truckingInfo.soNo" :so-no="soNo" :disabled="readonly" style="width:400px" />
        </el-form-item>
        <el-form-item v-if="elementDict.truckOrderNo.viewable" slot="truckOrderNo" class="custom">
          <line-label slot="label" :class="elementDict.truckOrderNo.isRequire ? 'blue' : ''" :label="elementDict.truckOrderNo.label" />
          <el-input
            v-model="truckingInfo.truckOrderNo"
            no="19"
            :disabled="readonly || !!truckingInfo.carFormUuid"
            style="width:400px"
            @change="checkTruckOrderNo();refreshTopGrid()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.truckingFee.viewable" slot="truckingFee" class="custom">
          <line-label slot="label" :class="elementDict.truckingFee.isRequire ? 'blue' : ''" :label="elementDict.truckingFee.label" />
          <div style="display: flex;">
            <el-input-number
              no="40"
              :value="truckingInfo.truckingFee"
              :disabled="readonly"
              :min="0"
              :max="999999999999"
              :precision="2"
              controls-position="right"
              style="width:118px;flex-grow:1;"
              @input="value=>{truckingFeeCharge(value||0)}"
            />
            <cargo-advance-select
              no="currency"
              :disabled="readonly"
              :select-type="TYPE_NAMES.basic_data_Currency"
              filterable
              :clearable="false"
              :default-value="truckingInfo.currency"
              style="width:118px;margin-left:5px"
              @parentCallBack="onCurrencyChange"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortAdditionalFee && elementDict.destinationPortAdditionalFee.viewable" slot="destinationPortAdditionalFee" class="custom">
          <line-label slot="label" :class="elementDict.destinationPortAdditionalFee.isRequire ? 'blue' : ''" :label="elementDict.destinationPortAdditionalFee.label" />
          <el-input
            v-model="truckingInfo.destinationPortAdditionalFee"
            no="destinationPortAdditionalFee"
            :disabled="readonly"
            type="textarea"
            :rows="3"
            style="width:400px"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.driverTel.viewable && !isSalesForSzfs" slot="driverTel" class="custom">
          <line-label slot="label" :class="elementDict.driverTel.isRequire ? 'blue' : ''" :label="elementDict.driverTel.label" />
          <el-input v-model="truckingInfo.driverTel" no="41" :disabled="readonly" style="width:400px" @change="refreshTopGrid" />
        </el-form-item>
        <el-form-item v-if="elementDict.actLoadingDate.viewable" slot="actLoadingDate" class="custom">
          <line-label slot="label" :class="elementDict.actLoadingDate.isRequire ? 'blue' : ''" :label="elementDict.actLoadingDate.label" />
          <el-date-picker
            ref="actLoadingDate"
            v-model="truckingInfo.actLoadingDate"
            no="42"
            :disabled="readonly"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width:400px"
            @blur="()=> { handleBlur('actLoadingDate', null, true, true, truckingInfo) }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plateNumber.viewable" slot="plateNumber" class="custom">
          <line-label slot="label" :class="elementDict.plateNumber.isRequire ? 'blue' : ''" :label="elementDict.plateNumber.label" />
          <el-input
            v-if="isEdit"
            v-model="truckingInfo.plateNumber"
            no="43"
            style="width:280px;"
            @input="(val)=>{truckingInfo.plateNumber = val.trim()}"
          />
          <span v-if="readonly" class="plate_number">{{ truckingInfo.plateNumber }}</span>
        </el-form-item>
        <el-form-item v-if="elementDict.driverPhone.viewable && !isSalesForSzfs" slot="driverPhone" :disabled="txtEditEable" class="custom">
          <line-label slot="label" :class="elementDict.driverPhone.isRequire ? 'blue' : ''" :label="elementDict.driverPhone.label" />
          <el-input v-model="truckingInfo.driverPhone" no="45" :disabled="readonly" style="width:400px;" />
        </el-form-item>
        <el-form-item v-if="elementDict.doorName.viewable" slot="doorName" class="custom">
          <line-label slot="label" :class="elementDict.doorName.isRequire ? 'blue' : ''" :label="elementDict.doorName.label" />
          <cargo-repeat-value-select
            v-model="truckingInfo.doorName"
            :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
            filterable
            :allow-create="true"
            :disabled="readonly"
            clearable
            :options="doorList"
            label-field="name"
            value-field="name"
            unique-field="uuid"
            :match-of-repeat-value="matchOfRepeatDoor"
            style="width: 400px"
            @change="doorsChangeHandler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.doorManTel.viewable" slot="doorManTel" class="custom">
          <line-label slot="label" :class="elementDict.doorManTel.isRequire ? 'blue' : ''" :label="elementDict.doorManTel.label" />
          <el-input v-model="truckingInfo.doorManTel" no="46" :disabled="readonly" style="width:400px" />
        </el-form-item>
        <el-form-item v-if="elementDict.remarks.viewable" slot="remarks">
          <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
          <el-input
            v-model="truckingInfo.remarks"
            no="47"
            :disabled="readonly"
            :filter-chars="false"
            type="textarea"
            :rows="3"
            style="width:400px"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.palletSum.viewable" slot="palletSum" class="custom">
          <line-label slot="label" :class="elementDict.palletSum.isRequire ? 'blue' : ''" :label="elementDict.palletSum.label" />
          <el-input-number
            no="18"
            style="width:400px;"
            :value="truckingInfo.palletSum"
            :disabled="readonly"
            :min="0"
            :max="999999999999"
            :precision="0"
            :controls="false"
            @input="val=>{truckingInfo.palletSum=val || 0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.palletDetail && elementDict.palletDetail.viewable" slot="palletDetail">
          <line-label slot="label" :class="elementDict.palletDetail.isRequire ? 'blue' : ''" :label="elementDict.palletDetail.label" />
          <cargo-textarea v-model="truckingInfo.palletDetail" no="agentInformation" type="textarea" :row="3" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.palletSize && elementDict.palletSize.viewable" slot="palletSize">
          <line-label slot="label" :class="elementDict.palletSize.isRequire ? 'blue' : ''" :label="elementDict.palletSize.label" />
          <cargo-textarea v-model="truckingInfo.palletSize" no="agentInformation" type="textarea" :row="3" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.dischargingWay.viewable" slot="dischargingWay">
          <line-label slot="label" :class="elementDict.dischargingWay.isRequire ? 'blue' : ''" :label="elementDict.dischargingWay.label" />
          <el-select
            :value="truckingInfo.dischargingWay?truckingInfo.dischargingWay.split(','):[]"
            no="48"
            :disabled="readonly"
            multiple
            style="width:400px"
            @input="value=>{truckingInfo.dischargingWay=value.join(',')}"
          >
            <el-option value="DROP" />
            <el-option value="LIVE UNLOAD" />
            <el-option value="EXCHANGE PALLETS" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.actDeliveryDate.viewable" slot="actDeliveryDate">
          <line-label slot="label" :class="elementDict.actDeliveryDate.isRequire ? 'blue' : ''" :label="elementDict.actDeliveryDate.label" />
          <el-date-picker
            ref="actDeliveryDate"
            v-model="truckingInfo.actDeliveryDate"
            no="actDeliveryDate"
            :disabled="readonly"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width:400px"
            @blur="()=> { handleBlur('actDeliveryDate', null, true, true, truckingInfo) }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.boxesNumber.viewable" slot="boxesNumber">
          <line-label slot="label" :class="elementDict.boxesNumber.isRequire ? 'blue' : ''" :label="elementDict.boxesNumber.label" />
          <el-input
            v-model="truckingInfo.boxesNumber"
            type="text"
            no="61"
            :disabled="readonly"
            style="width:400px"
            @input="truckingInfo.boxesNumber = truckingInfo.boxesNumber.replace(/[^0-9]/g, '')"
          />
        </el-form-item>
      </template>
      <!--      远程订舱排除掉这个列表-->
      <div v-show="pageSource !== 'remoteBooking'" slot="containerInfo2" class="section">
        <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
        <div v-if="!isMaster" class="app-main-inner-row operations">
          <div v-show="cooperateEdit" class="triggers">
            <div>
              <el-button
                no="48"
                type="primary"
                :disabled="!linkUsageEnable"
                @click="linkUsageClickHandler"
              >{{ $t('SeaExport.AddPackingInfo') }}</el-button>
              <el-button
                no="49"
                type="danger"
                :disabled="!linkUsageEnable"
                @click="delLinkUsageClickHandler"
              >{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
            </div>
          </div>
        </div>
        <div style="flex-grow:1;padding:10px">
          <cargo-ag-grid
            no="52"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="usages"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
    </tab-discharging-trucking-UICustom-layout>
    <!-- 选择装箱信息弹窗 -->
    <discharging-trucking-container-usage-link-dialog
      :visible.sync="containerUsageDialog.visible"
      :job-uuid="job.uuid"
      :trucking-info-uuid="truckingInfo.uuid"
      :serial-nos="containerUsageDialog.serialNos"
      @selectContainerUsageHandler="selectContainerUsageHandler"
    />
    <!-- 附件 -->
    <upload-common-file :visible.sync="uploadCommonFileDialog.visible" :model="uploadCommonFileDialog.model" />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabDischargingTruckingUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTruckingUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabDischargingTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTrucking'
import StrUtils from '@/utils/StrUtils'
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea.vue'

export default {
  name: 'TabTruckingUICustom',
  components: { cargoTextarea, tabDischargingTruckingUICustomLayout },
  extends: tabDischargingTrucking,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null // 用于调用父级的方法
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
        // 兜底：后端UICustom配置未包含新增字段 destinationPortAdditionalFee（目的港附加费）时，
        // 补充默认配置，使其跟随 truckingFee（拖车费）所在区块显示，与非UICustom版本保持一致
        if (!this.elementDict.destinationPortAdditionalFee) {
          const targetBlock = this.elementBlocks.find(b => b.elementNames && b.elementNames.includes('truckingFee'))
          if (targetBlock && !targetBlock.elementNames.includes('destinationPortAdditionalFee')) {
            const feeIdx = targetBlock.elementNames.indexOf('truckingFee')
            targetBlock.elementNames.splice(feeIdx + 1, 0, 'destinationPortAdditionalFee')
          }
          this.$set(this.elementDict, 'destinationPortAdditionalFee', {
            visible: true,
            viewable: true,
            writable: true,
            isRequire: false,
            label: this.$t('SeaExport.DestinationPortAdditionalFee'),
            fieldNames: ['destinationPortAdditionalFee']
          })
          this.$set(this.fieldDict, 'destinationPortAdditionalFee', {
            visible: true,
            isRequire: false,
            label: this.$t('SeaExport.DestinationPortAdditionalFee')
          })
        }
      }
    },
    validateRequire(truckingList) {
      for (const form of truckingList) {
        for (const name in this.elementDict) {
          const element = this.elementDict[name]
          if (!element.viewable || !element.writable || !element.isRequire) {
            continue
          }
          if (!element.fieldNames) {
            continue
          }
          if (name === 'soNo') {
            if (!this.job.multipleDischargingPickups) {
              continue
            }
          }
          for (const fieldName of element.fieldNames) {
            const field = this.fieldDict[fieldName]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabDischargingTrucking')
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-discharging-trucking /deep/ {
  .el-form-item {
    .so-no-selector{
      & > span{
        &:first-of-type{
          flex: 1;
        }
      }
    }
  }
  .el-form {
    .plate_number{
      width: 280px;
      height: 28px;
      box-sizing: border-box;
      padding-left: 10px;
      vertical-align: middle;
      background-color: #f3f4f5;
      border: 1px solid #E4E7ED;
      color: blue;
      text-decoration: underline;
      cursor: pointer;
      display: inline-block;
    }
    .vehicle-btn{
      margin-left: 10px;
    }
    .vehicle-tip{
      margin-left: 5px;
      font-size: 16px;
      color: #1F75D5;
    }
  }
}
</style>
